/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/262-point-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15 6.5V9a1.502 1.502 0 01-2.236 1.307 1.5 1.5 0 01-2.264.31 1.494 1.494 0 01-1.5.297V14.5c0 .827-.673 1.5-1.5 1.5S6 15.327 6 14.5V8.333L3.25 9.799a1.502 1.502 0 01-1.789-2.381l.012-.011L5.21 4H4.5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-.691l1.138 2.276A.496.496 0 0115 6.5zm-1-4a.5.5 0 10-1 0 .5.5 0 001 0zm0 4.118L12.691 4H6.694L2.15 8.143a.5.5 0 00.614.782l3.5-1.866a.502.502 0 01.735.442v7a.5.5 0 001 0v-5a.5.5 0 011 0 .5.5 0 001 0 .5.5 0 011 0 .5.5 0 001 0v-.5a.5.5 0 011 0 .5.5 0 001 0V6.619z"/>'
  }
})
